// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".faq-modal-doc .modal-body {\n  padding: 0px;\n}\n.faq-modal-doc .disabled_not_restore input.disabled_cursor,\n.faq-modal-doc .disabled_not_restore textarea.disabled_cursor {\n  background-color: inherit !important;\n}", ""]);
// Exports
module.exports = exports;
